<img *ngIf="!user.photo" class="user-photo" [src]="userPhotoUrl" />
<hfc-image *ngIf="user.photo" [file]="user.photo" class="user-photo"></hfc-image>

<div class="user-info">
  <span class="text-small-medium-secondary">{{ user.fullName }}</span>
  <span *ngIf="showRole" class="text-small-grey60">{{ user.isLead ? 'Lead Applicant' : 'Sub Applicant' }}</span>
  <span *ngIf="showEmail" class="text-small-grey60">{{ user.email }}</span>
</div>
